import { NgModule, importProvidersFrom } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { getTranslateModule } from 'app/utils/get-translate-module';
import { faqMainTranslateLoaderFactory } from './translate-loaders/faq-v2-main-translate-loader.factory';
import { faqSearchTranslateLoaderFactory } from './translate-loaders/faq-v2-search-translate-loader.factory';
import { faqDetailTranslateLoaderFactory } from './translate-loaders/faq-v2-detail-translate-loader.factory';
import { faqCategoryTranslateLoaderFactory } from './translate-loaders/faq-v2-category-translate-loader.factory';

const routes: Routes = [
  {
    path: '',
    providers: [importProvidersFrom(getTranslateModule(faqMainTranslateLoaderFactory))],
    loadComponent: () => import('./faq-home/faq-main/faq-main.component').then((c) => c.FaqMainComponent),
  },
  {
    path: 'search',
    data: {
      breadcrumb: [
        {
          label: 'Faq',
          url: '/faq',
        },
        {
          label: '{{searchResultLabel}}',
          url: '',
          isDynamicLabel: true,
        },
      ],
    },
    providers: [importProvidersFrom(getTranslateModule(faqMainTranslateLoaderFactory))],
    loadComponent: () =>
      import('./faq-search-result/faq-search-result-main/faq-search-result-main.component').then(
        (c) => c.FaqSearchResultMainComponent,
      ),
  },
  {
    path: 'search/:searchText',
    data: {
      breadcrumb: [
        {
          label: 'FAQ',
          url: '/faq',
        },
        {
          label: '{{searchResultLabel}}',
          url: '',
          isDynamicLabel: true,
        },
      ],
    },
    providers: [importProvidersFrom(getTranslateModule(faqSearchTranslateLoaderFactory))],
    loadComponent: () =>
      import('./faq-search-result/faq-search-result-main/faq-search-result-main.component').then(
        (c) => c.FaqSearchResultMainComponent,
      ),
  },
  {
    path: 'questions/:questionSlug',
    data: {
      breadcrumb: [
        {
          label: 'FAQ',
          url: '/faq',
        },
        {
          label: '{{category}}',
          url: '/faq/category/:categorySlug',
          isDynamicLabel: true,
        },
        {
          label: '{{question}}',
          url: '',
          isDynamicLabel: true,
        },
      ],
    },
    providers: [importProvidersFrom(getTranslateModule(faqDetailTranslateLoaderFactory))],
    loadComponent: () =>
      import('./faq-detail/faq-detail-main/faq-detail-main.component').then((c) => c.FaqDetailMainComponent),
  },
  {
    path: 'category/:categoryName',
    data: {
      breadcrumb: [
        {
          label: 'FAQ',
          url: '/faq',
        },
        {
          label: '{{categorySlug}}',
          url: '',
          isDynamicLabel: true,
        },
      ],
    },
    providers: [importProvidersFrom(getTranslateModule(faqCategoryTranslateLoaderFactory))],
    loadComponent: () =>
      import('./faq-category/faq-category-main/faq-category-main.component').then((c) => c.FaqCategoryMainComponent),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
})
export class FaqV2RoutingModule {}
